import React from 'react';
interface SplineLoaderProps {
  onEnter: () => void;
}
export const SplineLoader: React.FC<SplineLoaderProps> = ({
  onEnter
}) => {
  return <div className="fixed inset-0 z-50 bg-black" data-id="element-231">
      <iframe src="https://my.spline.design/rooftopswing-bsD8mVkA1g0uUimqIyRvk7Rt/" frameBorder="0" width="100%" height="100%" title="Spline Animation" data-id="element-232" />
      <div className="absolute inset-x-0 bottom-10 flex justify-center" data-id="element-233">
        <button onClick={onEnter} className="font-display italic bg-red-600 hover:bg-red-700 text-white py-3 px-8 rounded-full transition duration-300 backdrop-blur-sm" data-id="element-234">
          Enter Site
        </button>
      </div>
    </div>;
};